import React, { useState } from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  ListItem,
} from "@material-ui/core";
import { CloseIconButton } from "../../shared/Buttons/CloseIconButton";
import {
  EventDatesUserContent,
  EventField,
  EventGroupUserList,
} from "../Event.style";
import { useMutation, useQuery } from "@apollo/client";
import {
  EventDateAbsentUserDocument,
  EventDateAbsentUserMutation,
  GetEventDateDocument,
  GetEventDateQuery,
} from "../../../generated/graphql";
import { LoadingBox } from "../../shared/Style/Style";
import { ErrorSnackbar } from "../../shared/Error/ErrorSnackbar";
import { ExportUserExel } from "../ExportUsersExel/ExportUsersExel";
import { DeleteIconButton } from "../../shared/Buttons/DeleteIconButton";

interface IEventWerePresent{
  eventDateId:string;
  open:boolean;
  close():void;
}

export const EventWerePresentModal = ({ eventDateId, open, close }:IEventWerePresent) => {
  const [searchedUser, setSearchedUser] = useState("");

  const { data, loading, error } = useQuery<GetEventDateQuery>(
    GetEventDateDocument,
    {
      variables: {
        id: eventDateId,
      },
    }
  );

  const [
    eventDateAbsentUser,
    { loading: eventDateAbsentUserLoading, error: eventDateAbsentUserError },
  ] = useMutation<EventDateAbsentUserMutation>(EventDateAbsentUserDocument, {
    refetchQueries: [
      {
        query: GetEventDateDocument,
        variables: {
          id: eventDateId,
        },
      },
    ],
  });

  const closeHandler = () => {
    setSearchedUser("");
    close();
  };

  let content;

  if (loading || eventDateAbsentUserLoading) {
    return (
      <LoadingBox>
        <CircularProgress color="inherit" />
      </LoadingBox>
    );
  }
  if (error || eventDateAbsentUserError) {
    return <ErrorSnackbar error={error || eventDateAbsentUserError} />;
  }
  if (data) {
    const presentUser = data?.getEventDate?.werePresent;

    const searchUsers = presentUser
      .map((user) => {
        if (
          !user.firstName
            .toLocaleLowerCase()
            .includes(searchedUser.toLocaleLowerCase()) &&
          !user.lastName
            .toLocaleLowerCase()
            .includes(searchedUser.toLocaleLowerCase())
        ) {
          return null;
        }
        return user;
      })
      .filter((user) => user);

    content = (
      <>
        <Box display="flex" alignItems="center">
          <EventField
            fullWidth
            label="Поиск участников"
            value={searchedUser}
            onChange={({ target }) => setSearchedUser(target.value)}
          />
          <ExportUserExel data={presentUser} />
        </Box>
        <EventGroupUserList>
          {searchUsers?.length
            ? searchUsers?.map((user, i) => {
                if (user === null) {
                  return null;
                }

                return (
                  <ListItem button key={user.id} disabled={false}>
                    <Box display="flex" alignItems="center">
                      {user?.firstName} {user?.lastName}
                      <DeleteIconButton
                        deleteHandler={() =>
                          eventDateAbsentUser({
                            variables: { eventDateId, userId: user?.id },
                          })
                        }
                        item={`${user?.firstName} ${user?.lastName}`}
                      />
                    </Box>
                  </ListItem>
                );
              })
            : "На данный момент нету посетивших участников"}
        </EventGroupUserList>
      </>
    );
  }

  return (
    <Dialog open={open}>
      <CloseIconButton close={closeHandler} />
      <Box textAlign="center" mb={2}>
        <DialogTitle>Посетившие участники</DialogTitle>
        <EventDatesUserContent style={{ width: "400px" }}>
          {content}
        </EventDatesUserContent>
      </Box>
    </Dialog>
  );
};
